// extracted by mini-css-extract-plugin
export default {"icon-button":"FormCategories_icon-button__NAcxE","card-body":"FormCategories_card-body__rug1v","fa-lg":"FormCategories_fa-lg__B4CqN","actionBtns":"FormCategories_actionBtns__oUvua"};